export enum OnlinePaymentEnum {
  Visa_MasterCard = 'Visa_MasterCard',
  Mada = 'Mada',
  ApplePay = 'ApplePay',
  STCPay = 'STCPay'
}
